import React from 'react';
import { IcGrid, IcUsers, IcUser, IcCamera, IcClock, IcMapPin, IcBus, IcAlertTriangle, IcShield, IcKey, IcWatch, IcVideo } from './Icons';

const nav = [
  { id: 'dashboard', label: 'Tableau de bord',  Icon: IcGrid },
  { id: 'students',  label: 'Élèves',            Icon: IcUsers },
  { id: 'teachers',  label: 'Enseignants',        Icon: IcUser },
  { id: 'scan',      label: 'Reconnaissance',     Icon: IcCamera },
  { id: 'events',    label: 'Historique',         Icon: IcClock },
  { id: 'cameras',   label: 'Caméras IP',         Icon: IcVideo },
  { id: 'gps',       label: 'Montres GPS',        Icon: IcWatch },
  { id: 'map',       label: 'Carte & GPS',        Icon: IcMapPin },
  { id: 'unknowns',  label: 'Inconnus',           Icon: IcAlertTriangle },
  { id: 'apikeys',   label: 'Clés API',           Icon: IcKey },
];

export default function Sidebar({ tab, setTab }) {
  return (
    <aside style={{
      width: 236, flexShrink: 0,
      background: 'var(--navy)',
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      position: 'sticky', top: 0, height: '100vh',
    }}>
      {/* Logo */}
      <div style={{ padding: '20px 20px 18px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img
            src="https://chefdeclasse.com/files/logo_256.png"
            alt="Chef de Classe"
            style={{ width: 36, height: 36, objectFit: 'contain', flexShrink: 0, borderRadius: 10 }}
          />
          <div>
            <div style={{ color: '#fff', fontWeight: 700, fontSize: 15, letterSpacing: '-0.01em' }}>Chef de Classe</div>
            <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: 11 }}>Sécurité scolaire</div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, padding: '12px 10px', overflowY: 'auto' }}>
        <div style={{ marginBottom: 4, padding: '0 10px 6px', color: 'rgba(255,255,255,0.25)', fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          Menu
        </div>
        {nav.map(({ id, label, Icon }) => {
          const active = tab === id;
          return (
            <button key={id} onClick={() => setTab(id)} style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: 10,
              padding: '9px 12px', borderRadius: 8, border: 'none',
              background: active ? 'var(--indigo)' : 'transparent',
              color: active ? '#fff' : 'rgba(255,255,255,0.45)',
              cursor: 'pointer', fontSize: 13, fontWeight: active ? 600 : 400,
              transition: 'all 0.15s', marginBottom: 2, textAlign: 'left',
            }}
            onMouseEnter={e => { if (!active) e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = '#fff'; }}
            onMouseLeave={e => { if (!active) { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,0.45)'; } }}
            >
              <Icon size={16} strokeWidth={active ? 2 : 1.5} />
              {label}
            </button>
          );
        })}
      </nav>

      {/* Footer */}
      <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'rgba(99,102,241,0.25)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <IcUser size={14} stroke="var(--indigo)" strokeWidth={2} />
          </div>
          <div>
            <div style={{ color: '#fff', fontSize: 12, fontWeight: 600 }}>Admin École</div>
            <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11 }}>École Pilote Abidjan</div>
          </div>
        </div>
      </div>
    </aside>
  );
}
